import CardWithTitle from 'components/CardWithTitle';
import React, { useState } from 'react';
import { Button, Col, Label, Row } from 'reactstrap';
import { HiArrowNarrowRight } from 'react-icons/hi';
import FSBModal from 'components/common/FSBModal';
import BiddingDetails from 'pages/BiddingOrders/components/BiddingDetails';

const BidsInfoDetail = ({ row, acceptedBids, rejectedBids }) => {
  const [selectedRow, setShowBiddingDetails] = useState(null);

  const drawerToggle = () => {
    setShowBiddingDetails(null);
  };
  const handleClick = () => {
    setShowBiddingDetails(row);
  };

  return (
    <>
      <FSBModal
        open={selectedRow}
        size="xl"
        title="Bidding Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        onConfirmClick={drawerToggle}
        modalClass="right-drawer"
      >
        {selectedRow && (
          <BiddingDetails row={selectedRow} data={[]} buttonDisabled />
        )}
      </FSBModal>
      <CardWithTitle title="Bids">
        <Button
          color="link"
          className="text-decoration-none card-right-btn text-dark-525 font-manrope fw-bold f-12 p-0"
          onClick={handleClick}
        >
          View all <HiArrowNarrowRight className="ms-1" size={18} />
        </Button>
        <Row className="mb-2">
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block text-uppercase">
              ACCEPTED BIDS
            </span>
            <Label className="f-12 fw-medium">{acceptedBids || 0}</Label>
          </Col>
          <Col sm={8}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block text-uppercase">
              CANCELLED/ REJECTED
            </span>
            <Label className="f-12 fw-medium">{rejectedBids || 0}</Label>
          </Col>
        </Row>
      </CardWithTitle>
    </>
  );
};

export default BidsInfoDetail;
